import { Briefcase, Plane, GraduationCap, Compass, CalendarDays, LayoutDashboard } from "lucide-react";
import { motion } from "framer-motion";
import { useScrollAnimation } from "@/hooks/use-scroll-animation";

const features = [
  { icon: Briefcase, title: "Find job", description: "Udforsk relevante job og frivilligt arbejde i Danmark og udlandet." },
  { icon: Plane, title: "Find rejse", description: "Sammenlign rejsemuligheder og find den perfekte tur til dit sabbatår." },
  { icon: GraduationCap, title: "Udforsk højskole", description: "Find den højskole der matcher dine interesser og drømme." },
  { icon: Compass, title: "Bliv klogere på dig selv", description: "Personlige værktøjer der hjælper dig med at finde retning." },
  { icon: CalendarDays, title: "Planlæg dit sabbatår", description: "Hold styr på deadlines, budget og alle dine planer ét sted." },
  { icon: LayoutDashboard, title: "Få overblik", description: "Dashboard med dine næste skridt — altid opdateret og overskueligt." },
];

const FeaturesSection = () => {
  const { ref, isVisible } = useScrollAnimation(0.1);

  return (
    <section id="features" className="py-20 md:py-28 section-gradient-warm" ref={ref}>
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={isVisible ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          className="text-center mb-14"
        >
          <h2 className="text-heading md:text-display-sm text-foreground mb-4">
            Hvad kan du med MySabbat?
          </h2>
          <p className="text-lg text-muted-foreground max-w-xl mx-auto">
            Alt hvad du har brug for til et godt sabbatår — samlet i én app.
          </p>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {features.map((feature, i) => (
            <motion.div
              key={feature.title}
              initial={{ opacity: 0, y: 24 }}
              animate={isVisible ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              className="group glass-card rounded-2xl p-6 hover:shadow-lg hover:-translate-y-1 transition-all duration-300"
            >
              <div className="w-11 h-11 rounded-xl bg-accent/10 flex items-center justify-center mb-4 group-hover:bg-accent/20 transition-colors">
                <feature.icon className="w-5 h-5 text-accent" />
              </div>
              <h3 className="text-base font-semibold text-foreground mb-2">{feature.title}</h3>
              <p className="text-sm text-muted-foreground leading-relaxed">{feature.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
